import {
  DialogContent,
  Dialog,
  DialogProps,
  DialogActions,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { styled } from '@mui/styles';
import { memo } from 'react';
import { PmiDialogTitle } from 'shell/components/shared/dialog/title';

export const PmiDialog = styled((props: DialogProps) => <Dialog {...props} />)((props) => ({
  '& .MuiDialog-paper': props.fullScreen
    ? {
        minWidth: 'unset',
        maxWidth: '100%',
      }
    : {
        minWidth: '25rem',
        maxWidth: '30rem',
      },
}));

interface ExitModalProps {
  open: boolean;
  onClose: (open: boolean) => void;
  onConfirm: () => void;
}

const ExitModalComponent = ({ open, onClose, onConfirm }: ExitModalProps): React.ReactElement => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));
  return (
    <PmiDialog
      open={open}
      onClose={() => onClose(false)}
      aria-labelledby="alert-dialog-title"
      fullScreen={fullScreen}
      aria-describedby="alert-dialog-description"
    >
      <PmiDialogTitle id="alert-dialog-title" color="white" backgroundColor="cdmBrand">
        Attenzione!
      </PmiDialogTitle>
      <DialogContent style={{ padding: '30px 24px' }}>
        Annulla operazione comporta la perdita di tutti i dati digitati, si è sicuri di voler
        continuare?
      </DialogContent>
      <DialogActions>
        <PmiButton variant="contained" color="cdmBrand" type="button" onClick={() => onConfirm()}>
          Conferma annullo
        </PmiButton>
        <PmiButton variant="outlined" color="primary" type="button" onClick={() => onClose(false)}>
          chiudi
        </PmiButton>
      </DialogActions>
    </PmiDialog>
  );
};

ExitModalComponent.displayName = 'Modal exit';

const ExitModal = memo(ExitModalComponent);

export default ExitModal;
